enum DefaultFlowModelNodeText {
  START = 'Start',
  END = 'End',
  STEP_1 = 'Step 1',
  STEP_2 = 'Step 2',
  STEP_3 = 'Step 3'
}

export default DefaultFlowModelNodeText;
